import { action, computed, observable } from 'mobx';
import * as validator from 'validator';

import { Education, InputHighlight } from '../types';

const year = new Date().getFullYear();

class EducationEditorStore {
  private static _instance: EducationEditorStore;
  
  @observable public awaitServer: boolean = false;
  @observable public degree: string =  '';
  @observable public degreeBlurred: boolean =  false;
  @observable public edittingBlockId: number = 0;
  @observable public educations: Education[] = [];
  @observable public gradYear: number =  0;
  @observable public gradYearBlurred: boolean =  false;
  @observable public isEditModalActive: boolean = false
  @observable public major: string =  '';
  @observable public majorBlurred: boolean =  false;
  @observable public school: string =  '';
  @observable public schoolBlurred: boolean =  false;

  /**
   * Use EducationStore.instance to retrieve an instance of this class.
   */
  private constructor() { }

  /**
   * Instance of EducationStore.
   */
  public static get instance() {
    if (!this._instance) {
      this._instance = new EducationEditorStore();
    }

    return this._instance;
  }

  @computed
  public get isDegreeValid(): boolean {
    return this.degreeBlurred ? !validator.isEmpty(this.degree) : true;
  }

  @computed
  public get degreeHelpMessage(): string {
    return this.isDegreeValid ? '' : 'Please select degree';
  }

  @computed
  public get degreeHighlight(): InputHighlight {
    return this.isDegreeValid ? InputHighlight.INFO : InputHighlight.DANGER;
  }

  @computed
  public get isGradYearValid(): boolean {
    return this.gradYearBlurred
        ? this.gradYear <= year && this.gradYear >= (year - 100)
        : true;
  }

  @computed
  public get gradYearHelpMessage(): string {
    return this.isGradYearValid ? '' : `Must be between ${year - 100} - ${year}`;
  }

  @computed
  public get gradYearHighlight(): InputHighlight {
    return this.isGradYearValid ? InputHighlight.INFO : InputHighlight.DANGER;
  }

  @computed
  public get isMajorValid(): boolean {
    return this.majorBlurred ? !validator.isEmpty(this.major) : true;
  }

  @computed
  public get majorHelpMessage(): string {
    return this.isMajorValid ? '' : 'Please enter major';
  }

  @computed
  public get majorHighlight(): InputHighlight {
    return this.isMajorValid ? InputHighlight.INFO : InputHighlight.DANGER;
  }

  @computed
  public get isSchoolValid(): boolean {
    return this.schoolBlurred ? !validator.isEmpty(this.school) : true;
  }

  @computed
  public get schoolHelpMessage(): string {
    return this.isSchoolValid ? '' : 'Please enter school name';
  }

  @computed
  public get schoolHighlight(): InputHighlight {
    return this.isSchoolValid ? InputHighlight.INFO : InputHighlight.DANGER;
  }

  @action
  public checkReadyForSave = (): boolean => {
    this.degreeBlurred = true;
    this.gradYearBlurred = true;
    this.majorBlurred = true;
    this.schoolBlurred = true;
    return this.isDegreeValid && this.isGradYearValid && this.isMajorValid && this.isSchoolValid;
  }
}

export default EducationEditorStore;
export const educationEditorStore = EducationEditorStore.instance;


// WEBPACK FOOTER //
// ./src/stores/EducationEditorStore.ts